import { render, staticRenderFns } from "./EEscolhaDisciplinaPlanoSemanal.vue?vue&type=template&id=ca6e6bca"
import script from "./EEscolhaDisciplinaPlanoSemanal.vue?vue&type=script&lang=js"
export * from "./EEscolhaDisciplinaPlanoSemanal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports